export class Data
	constructor
		projects = []
	
	def init
		self.projects = [
			{
				id: 1,
				name: 'Canvas',
				title: 'A new page for publishing transformation',
				subtitle: 'A homegrown system for the entire news workflow to extend the functionalities of existing system. It is an innovative solution on top of any part of this workflow quickly with full control.',
				desc: [
					{ type: 'subhead', content: 'The Problem'},
					{ type: 'line', content: 'Everything started about 3 years ago, when the old system needs to renewal the contract. The technology department start to review the systems that newsroom using. They found that editorial users are spend time working around limitations of the old systems, but instead, focus on delivering business value. It\'s a problem across the industry. More and more leading publishers are moving their CMS in-house.'},
					{ type: 'img', content: import('./../images/projects/scmp/problems.png') },
					{ type: 'subhead', content: 'The Solution'},
					{ type: 'line', content: 'Build an end-to-end digital news publish management system is the key. With the newest, most adavaced trchnology is quickly implemented, the newroom focuses on delievering the best reporting possible for efficiency increased.'},
					{ type: 'img', content: import('./../images/projects/scmp/solution.png') },
					{ type: 'subhead', content: 'Competitive Analysis'},
					{ type: 'line', content: 'I have analyzed the 3 most popular tools surrounding this productivity area and the previous system they were using. I found that they are doing different UX approaches on handling many files and images to help the user achieve their goals. This then became my opportunity for the solution.'},
					{ type: 'img', content: import('./../images/projects/scmp/companies.png') },
					{ type: 'subhead', content: 'User Interviews'},
					{ type: 'line', content: 'Although I have tried the above projects above but still not sure which part is most concerned, I\'ve conducted interviews with 5 editors and 3 photographors who failed at achieving their daily workflow from the previous system. I\'ve asked them questions below to find trends on why they failed at some goals versus others then organized my data through affinity mapping.'},
					{ type: 'line', content: 'RESEARCH QUESTIONS:'},
					{ type: 'line', content: '1. Your Desk / Team?'},
					{ type: 'line', content: '2. Your role?'},
					{ type: 'line', content: '3. Which of the following application(s) you are using?'},
					{ type: 'line', content: '4. From 1 to 5, how would you like to rate the image / video search features in the previous system ? '},
					{ type: 'line', content: '5. Do you want to edit an article concurrently with your colleagues?'},
					{ type: 'line', content: '6. What was your biggest challenge, frustration or problem in the publishing tools?'},
					{ type: 'line', content: '7. Would you like to be one of the pilot users to help to test a new publishing tool?'},
					{ type: 'subhead', content: 'The Main Insight'},
					{ type: 'line', content: 'Based on the interviews, I\'ve noticed they are quite open to have a new system to smoothen the workflow. Their concern was the communication is broken, teams are circulating story drafts by email, no tracking, no trace. The CMS cluttered with features for other customers and slow down the publish speed.'},
					{ type: 'subhead', content: 'Setbacks + a new direction for news publishing'},
					{ type: 'line', content: 'At first, I spent some hours daily trying to play with previous system to understand why some of the users love/hate the system. The more time that i spent, i don\'t feel i learn more from the system - it is hard to follow the steps eventhogh i just looked for doing a simple story publish testing. Maybe there are too many unneccessary features display around the system. What if only keep the core features, will it help with get rid of the frustration?'},
					{ type: 'subhead', content: '3 major improvements in my design'},
					{ type: 'line', content: 'Based on various feedback from 400 newsroom users feedback, I continually iterated my design over the span of 3 years- with 3 major improvements:'},
					{ type: 'list', content: [
						'Redesign the publishing workflow between digital and print',
						'Customised the publishing features to fit the newsroom unique publishing culture',
						'Enhance the search experience on the historical record'
					]},
					{ type: 'subhead', content: 'The Final Product'},
					{ type: 'line', content: 'Sorry ;( due to the confidentiality of information, i cannot share the design to the public.'},
					{ type: 'subhead', content: 'What I\'d keep doing'},
					{ type: 'line', content: 'You didn\'t fail- you just found 100 ways that didn\'t work. From noticing mistakes in my UX/UI to uncovering more foundational UX problems in the new system, I\'m thankful to have constantly asked for feedback from my colleages and the users. Til now, I still push to have the system as best I could, and did not let my own thinking stop me from questioning if my own decisions were truly best for the user. '}
				],
				type: 'Publishing System design',
				tools: 'Figma, Photoshop',
				cover: import('./../images/banner_scmp.jpeg'),
				font: '#101010',
				bg: '#fff',
				year: '2019 - Present'
			},
			{
				id: 2,
				name: 'Anta Claus',
				title: 'Meet the festive chatbot in X\'mas',
				subtitle: 'Design for Leading UK toy retailer The Entertainer to bring a little extra magic to Christmas shopping on its website.',
				desc: [
					{ type: 'img', content: import('./../images/projects/chatbot/how.png') },
					{ type: 'line', content: 'Customers will be able to ask much-loved mascot Jack, dressed as Santa for the occasion, about all the toys and games they can buy this festive season as well as facts, jokes and information about Christmas, via both voice and text input.'},
					{ type: 'line', content: 'I designed the the whole prject with UX flow and the graphics. Added the animations in delivering the chatbot, Jack will answer toy - and Christmas related questions on all devices, with voice input available via the Chrome browser:'},
					{ type: 'subhead', content: 'How it work?' },
					{ type: 'list', content: [
						'Jack asks two profiling questions - age and price range - which allow him to use the information he has collected to provide a link to The Entertainer\'s existing gift finder',
						'Artificial intelligence via natural language processing identifies and classifies incoming customer questions, enabling Jack to give the most relevant response from his fixed database of answers',
						'Responses and relevant questions are \'trained\' by human helpers and can be continuously refined using new input or existing data from the live chat logs',
						'Jack is also able to answer customers\' questions by giving access to other relevant dynamic functionality via links such as the store finder or FAQ pages'
					] },
					{ type: 'subhead', content: 'Desktop version' },
					{ type: 'img', content: import('./../images/projects/chatbot/desktop.png') },
					{ type: 'subhead', content: 'Mobile version' },
					{ type: 'img', content: import('./../images/projects/chatbot/mobile.png') }
				],
				type: 'Chatbot design: UX/UI/Animations',
				tools: 'Figma, Photoshop',
				cover: import('./../images/banner_entertainer.jpeg'),
				img: [
					'',
					''
				],
				font: '#00F0FF',
				bg: '#2A3A92',
				year: '2017'
			},
			{
				id: 6,
				name: 'Insurance Claim',
				title: 'A mobile app to help customer find medical providers and submit claims',
				subtitle: 'The app has many useful functions including the ability to find a medical provider within the Now Health cashless network and submit a reimbursement claim in just a few simple touches.',
				desc: [
					{ type: 'img', content: import('./../images/projects/now/overview.png') },
					{ type: 'subhead', content: 'Search for the nearest medical provider' },
					{ type: 'line', content: 'The app will allow customers to search for their nearest medical provider from the network list using either their exact location or by typing a location or name of medical facility.  It can be used for in-patient and out-patient treatment and will provide a list of the top 100 providers that are closest to the location of the customer.'},
					{ type: 'line', content: 'A few more taps on the screen will also enable the customer to see the provider location on a map, make a call to book an appointment and add it into their calendars!'},
					{ type: 'img', content: import('./../images/projects/now/mobile1.png') },
					{ type: 'subhead', content: 'Transform to the digital claim and simplified the process ' },
					{ type: 'line', content: 'If a customer doesn\'t have access to the cashless network, they can use the new app to submit a reimbursement claim. To make it familiar, it is in the same format as the current claim form. Plus, once the customer has made a claim, and wishes to submit another, any previous information will have been saved to make the claiming process even quicker and simpler.'},
					{ type: 'img', content: import('./../images/projects/now/mobile2.png') }
				],
				type: 'App UX/UI design',
				tools: 'Figma, Photoshop',
				cover: import('./../images/banner_now.jpeg'),
				img: [
					'',
					''
				],
				font: '#6DFFF6',
				bg: '#4A2199',
				year: '2015'
			}
		]

	get list
		projects.map do(item)
			{ name: item.name, cover: item.cover }

	def getProject name
		projects.filter do(item)
			item.name.toLowerCase().replace(/\s+/g, '') === name


# SCMP
# Entertainer
# Tessel
# Mango
# Minimal

# (smaller font | big font | bg color#)
# - Publishing System design | SCMP
# - Chatbot design | The Entertainer
# - Website design | Tessel
# - Wechat HTML5 campaign design | Mango
# - E-commerce website design | Minimal
# - App design | Now

# SCMP: #FFFFFF
# Entertainer: #2A3A92
# Tessel: #DDBBB1
# Mango: #292D31
# Minimal: #93A87A
# Now Health: #4A2199

# SCMP: #101010
# Entertainer: #00F0FF
# Tessel: #5B443E
# Mango: #FFD600
# Minimal: #678642
# Now Health: #6DFFF6
